/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/modules/shop/components/artikel-aktionen-button/shop.artikel-aktionen-button.component.ts.
 */
import {ChangeDetectionStrategy, Component, Input, OnDestroy, SimpleChanges, TemplateRef, ViewChild} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {Artikel} from '../../../../models/artikel';
import {View} from '../../../../models/view';
import {BehaviorSubject, Subject} from 'rxjs';
import {ArtikelAktion} from '../../../../models/artikel-aktion';
import {ShopViewComponent} from '../view/shop.view.component';
import {takeUntil} from 'rxjs/operators';
import {AppArtikelAktionenService} from '../../../../services/app.artikel-aktionen.service';
import {AppSettingsService} from '../../../../services/app.app_settings.service';
import {ArtikelWithAktionen} from '../../../../models/artikel-with-aktionen';

/**
 * Zweck: Beschreibt class ShopArtikelAktionenButtonComponent und ihren Daten- oder Funktionsvertrag.
 */
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    // tslint:disable-next-line:component-selector
    selector: 'artikel-aktionen-button',
    templateUrl: 'shop.artikel-aktionen-button.component.html',
    styleUrls: ['shop.artikel-aktionen-button.component.scss'],
    standalone: false
})
export class ShopArtikelAktionenButtonComponent implements OnDestroy {
  @Input() artikel: Artikel;
  @Input() view: View;
  @Input() viewcomp: ShopViewComponent;
  @Input() popupMode = false;
  @ViewChild('actionPopup') actionPopup: TemplateRef<any>;

  aktionen: BehaviorSubject<ArtikelAktion[]> = new BehaviorSubject<ArtikelAktion[]>([]);

  _onDestroy = new Subject<void>();

/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(private artikelAktionenService: AppArtikelAktionenService, private ssvc: AppSettingsService,
              private dialog: MatDialog) {
  }

/**
 * Beschreibt Methode ngOnDestroy und ihren Rückgabevertrag.
 */
  ngOnDestroy(): void {
    this._onDestroy.next();
    this._onDestroy.complete();
    if (this.artikel && this.artikel.ArtikelHatAktion) {
      this.artikelAktionenService.unregisterListener(this.artikel);
      this.hideAktionen(this.artikel);
    }
  }

/**
 * Beschreibt Methode ngOnChanges und ihren Rückgabevertrag.
 */
  ngOnChanges(changes: SimpleChanges): void {
  }

/**
 * Beschreibt Methode showAktionen und ihren Rückgabevertrag.
 */
  showAktionen(artikel: Artikel) {
    this.viewcomp.showAktion(artikel, this.aktionen.value);
  }

/**
 * Beschreibt Methode hideAktionen und ihren Rückgabevertrag.
 */
  hideAktionen(artikel: Artikel) {
    this.viewcomp.hideAktionen(artikel);
  }

/**
 * Öffnet die vorhandenen Aktionsdetails als Dialog.
 */
  openPopup(): void {
    this.dialog.open(this.actionPopup, {width: 'min(1100px, 95vw)', maxWidth: '95vw'});
  }

/**
 * Liefert den Datenvertrag für die vorhandene Aktionsdetail-Komponente.
 * @return Artikel mit seinen geladenen Aktionen.
 */
  getPopupAktionen(): ArtikelWithAktionen {
    const result = new ArtikelWithAktionen();
    result.artikel = this.artikel;
    result.aktionen = this.aktionen.value;
    return result;
  }

/**
 * Beschreibt Methode ngOnInit und ihren Rückgabevertrag.
 */
  ngOnInit(): void {
    if (!this.artikel.view) {
      this.artikel.view = this.view;
    }
    if (this.artikel && this.artikel.ArtikelHatAktion) {
      this.artikelAktionenService.registerListener(this.artikel).pipe(takeUntil(this._onDestroy)).subscribe({
        next: (a) => {
          this.aktionen.next(a);
          if (!this.popupMode && this.viewcomp.showAktionenDefault) {
            if (a && a.length > 0) {
              setTimeout(() => {
                this.showAktionen(this.artikel);
              }, 200);
            }
          }
        }
      });
    }
  }
}
